var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.node && _vm.node.type === 'traverse' && !_vm.isMyself)?_c('div',{staticClass:"inline-block"},[_c('NEIcon',{attrs:{"color":'yellow',"img":require('../img/star-yellow.svg'),"label":"Visit StarMap"},on:{"click":_vm.onGo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }